import { addEventEntry } from '@printdeal/data-layer-manager';

import {
  dispatchDataLayerEventOnClick,
  dispatchDataLayerEventOnProductsClickGA4,
  dispatchDataLayerHomepageProductImpressionsGA,
} from '../../../../helpers/dataLayerHelpers/HomepageDataLayerHelper';
import { IImpressions } from '../../../../types/product/productDetailPage';
import { ProductListOnClick } from '../types';

const HOMEPAGE_NEWPRODUCTS = 'homepage_newproducts';

export const handleNewProductOnClick: ProductListOnClick = (position, productName) => {
  const eventPayload = {
    item: HOMEPAGE_NEWPRODUCTS,
    position,
  };
  const eventdata = { eventName: HOMEPAGE_NEWPRODUCTS, position, productName };
  dispatchDataLayerEventOnClick(eventPayload);
  dispatchDataLayerEventOnProductsClickGA4(eventdata);
};

export const handleNewProductsAllClick = () => {
  addEventEntry({ eventCategory: HOMEPAGE_NEWPRODUCTS, eventAction: 'click_all_products' });
};

export const observerCallbackOnNewProducts = (dataAttribute: IImpressions) => {
  dispatchDataLayerHomepageProductImpressionsGA(dataAttribute?.products, HOMEPAGE_NEWPRODUCTS);
};
